<div
  data-cy="uploadPdf"
  fxLayout="column"
  fxLayoutAlign="center center"
  (click)="ontaskSelect()"
  class="container"
>
  <img [src]="image" class="category-img" />
  <button mat-raised-button color="primary" class="button">{{ text }}</button>
</div>
